import { HorizontalScroll } from "./HorizontalScroll";
import { useMemo } from "react";

const displayCell = (value) => value === true ? "Yes" : value === false ? "No" : value ?? "—";

export const AssetImportPreview = ({ rows }) => {
  const columns = useMemo(() => [...new Set(rows.flatMap((row) => Object.keys(row)))], [rows]);
  if (!rows.length) return null;
  return (
    <div className="border border-slate-700 rounded-md overflow-hidden" data-testid="asset-import-preview">
      <p className="px-3 py-2 bg-slate-900/60 text-xs font-mono uppercase tracking-widest text-slate-400">Preview — {rows.length} valid row{rows.length !== 1 ? "s" : ""}</p>
      <HorizontalScroll testId="asset-import-preview-scroll" contentClassName="max-h-44">
        <table className="w-full text-xs">
          <thead><tr className="border-b border-slate-700/60 text-left">{columns.map((column) => <th key={column} className="px-3 py-1.5 text-slate-500 font-mono whitespace-nowrap">{column.replace(/_/g, " ").toUpperCase()}</th>)}</tr></thead>
          <tbody>{rows.slice(0, 10).map((row, index) => <tr key={`${row.asset_name}-${index}`} className="border-b border-slate-800/60" data-testid={`asset-import-preview-row-${index}`}>
            {columns.map((column) => <td key={column} className={`px-3 py-1.5 whitespace-nowrap max-w-[180px] truncate ${column === "asset_name" ? "text-amber-400 font-mono" : "text-slate-300"}`}>{displayCell(row[column])}</td>)}
          </tr>)}</tbody>
        </table>
        {rows.length > 10 && <p className="px-3 py-1.5 text-[10px] font-mono text-slate-500">+{rows.length - 10} more rows</p>}
      </HorizontalScroll>
    </div>
  );
};

export const CustomerImportPreview = ({ rows }) => {
  if (!rows.length) return null;
  return (
    <div className="border border-slate-700 rounded-md overflow-hidden" data-testid="import-preview">
      <p className="px-3 py-2 bg-slate-900/60 text-xs font-mono uppercase tracking-widest text-slate-400">Preview — {rows.length} valid row{rows.length !== 1 ? "s" : ""}</p>
      <HorizontalScroll testId="customer-import-preview-scroll" contentClassName="max-h-44">
        <table className="w-full text-xs">
          <thead><tr className="border-b border-slate-700/60 text-left"><th className="px-3 py-1.5 text-slate-500 font-mono">NAME</th><th className="px-3 py-1.5 text-slate-500 font-mono">CONTACT</th><th className="px-3 py-1.5 text-slate-500 font-mono">EMAIL</th><th className="px-3 py-1.5 text-slate-500 font-mono">PHONE</th></tr></thead>
          <tbody>{rows.slice(0, 10).map((row, index) => <tr key={`${row.name}-${row.email || index}`} className="border-b border-slate-800/60" data-testid={`import-preview-row-${index}`}><td className="px-3 py-1.5 text-slate-200">{row.name}</td><td className="px-3 py-1.5 text-slate-400">{row.contact_name || "—"}</td><td className="px-3 py-1.5 text-slate-400">{row.email || "—"}</td><td className="px-3 py-1.5 text-slate-400">{row.phone || "—"}</td></tr>)}</tbody>
        </table>
        {rows.length > 10 && <p className="px-3 py-1.5 text-[10px] font-mono text-slate-500">+{rows.length - 10} more rows</p>}
      </HorizontalScroll>
    </div>
  );
};
